function openTab(event, tabId) {
  // Remove 'active' class from all tabs and tab content
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");
  tabButtons.forEach((button) => button.classList.remove("active"));
  tabContents.forEach((content) => content.classList.remove("active"));

  // Add 'active' class to clicked tab and related content
  event.currentTarget.classList.add("active");
  document.getElementById(tabId).classList.add("active");
}

var swiper = new Swiper(".tabProducts", {
  slidesPerView: 1,
  spaceBetween: 10,
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 4,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 4,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 4,
    },
  },
});
